// situacao da admissao completa
export enum SituacaoAdmissaoEnum {
	ABERTA = -1,
	ENVIADA = 0,
    EFETUADA = 1,
    CANCELADA = 2,
    EXCLUIDA = 3,
    RECUSADA = 4
}
